import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const AVOIR_MODALITY_TEMPLATES = {
  imputation: (facture) => `Cet avoir sera imputé sur la facture ${facture || "d'origine"}`,
  remboursement: () => "Remboursement par virement sous 30 jours",
};

// Modalité pré-remplie d'après le défaut de la société (identique au backend document_guards.py)
export const defaultAvoirModality = (companySettings, sourceNumber) => {
  const builder = AVOIR_MODALITY_TEMPLATES[companySettings?.default_avoir_modality];
  return builder ? builder(sourceNumber) : "";
};

// Champ unique, partagé par les deux formulaires de document : il ne peut donc plus
// manquer sur un chemin et pas sur un autre. L'affichage dépend du TYPE du document.
export function AvoirModalityField({ form, setForm }) {
  const empty = !(form.avoir_modality || "").trim();
  return (
    <div data-testid="avoir-modality-field">
      <Label htmlFor="avoir-modality">Modalité de l&apos;avoir</Label>
      <Select
        value={form.avoir_modality_type || "libre"}
        onValueChange={v => setForm(prev => ({
          ...prev,
          avoir_modality_type: v === "libre" ? "" : v,
          avoir_modality: v === "libre"
            ? prev.avoir_modality
            : AVOIR_MODALITY_TEMPLATES[v](prev.source_doc_number),
        }))}
      >
        <SelectTrigger className="mb-2 mt-1" data-testid="doc-avoir-modality-type"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="imputation">Imputation sur la facture</SelectItem>
          <SelectItem value="remboursement">Remboursement</SelectItem>
          <SelectItem value="libre">Autre (texte libre)</SelectItem>
        </SelectContent>
      </Select>
      <Input
        id="avoir-modality"
        value={form.avoir_modality || ""}
        onChange={e => setForm(prev => ({ ...prev, avoir_modality: e.target.value }))}
        placeholder="Texte imprimé sur l'avoir"
        className={empty ? "border-rose-300 focus-visible:ring-rose-200" : ""}
        data-testid="doc-avoir-modality"
      />
      <p className={`text-[11px] mt-1 ${empty ? "text-rose-600 font-medium" : "text-slate-500"}`} data-testid="avoir-modality-hint">
        {empty
          ? "À préciser avant l'émission : l'avoir ne pourra pas être émis sans modalité."
          : "« Imputation » déduit l'avoir du reste dû de la facture d'origine."}
      </p>
    </div>
  );
}
